/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';

function apiRequest(apiConfig: ApiRequestConfig): Promise<any> {
	const config: AxiosRequestConfig = {
		url: apiConfig.path,
		method: apiConfig.method,
		params: apiConfig.query,
		data: apiConfig.body,
		headers: apiConfig.headers,
		timeout: apiConfig.timeout,
		responseType: apiConfig.responseType,
	};

	return new Promise((resolve, reject) => {
		axios(config)
			.then((response: any) => {
				resolve(response.data);
			})
			.catch((error: any) => {
				if (error.toJSON().message === 'Network Error') {
					toast.error(
						'Tidak ada koneksi internet, harap periksa jaringan Anda dan coba lagi.'
					);
				}
				if (error.response.status === 400) {
					if (error.response.data.error_description) {
						reject(error.response.data.error_description);
					} else if (error.response.data.message) {
						reject(error.response.data.message);
					}
				} else if (error.response.status === 401) {
					const timeOut = 6500;
					toast.warning(
						'Sesi anda telah berakhir. Silakan login kembali untuk akses dashboard'
					);
					localStorage.clear();
					setTimeout(() => {
						window.location.reload();
					}, timeOut);
				} else if (error.response.status === 500) {
					const timeOut = 3000;
					toast.error(
						'Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.'
					);
					setTimeout(() => {
						window.location.reload();
					}, timeOut);
				}
			});
	});
}

export default apiRequest;
